import { Select } from './ui';
import { useAdminUsers, useCurrentUser } from '../hooks';
import styles from './AuthorFilter.module.css';

interface Props {
  value: string;
  onChange: (login: string) => void;
}

export function AuthorFilter({ value, onChange }: Props) {
  const { isAdmin } = useCurrentUser();
  const users = useAdminUsers(isAdmin);
  if (!isAdmin) return null;

  const logins = (users.data ?? []).map((user) => user.username).sort();
  return (
    <Select
      size="sm"
      className={styles.filter}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      aria-label="Сотрудник"
    >
      <option value="">Все сотрудники</option>
      {logins.map((login) => (
        <option key={login} value={login}>
          {login}
        </option>
      ))}
    </Select>
  );
}
